import Header from "components/header/Header";
import MobileOverlay from "components/sidebar/MobileOverlay";
import Sidebar from "components/sidebar/Sidebar";
import AppContent from "layouts/AppContent";
import useSidebar from "hooks/useSidebar";

export default function MainLayout() {
  const { isCollapsed } = useSidebar();

  return (
    <div className="min-h-screen bg-surface text-text-900">
      <Sidebar />
      <MobileOverlay />
      <div
        className={`transition-[margin] duration-300 ease-out md:ml-20 ${
          isCollapsed ? "md:ml-20" : "md:ml-64"
        }`}
      >
        <Header />
        <AppContent />
      </div>
    </div>
  );
}
